module.exports = __webpack_public_path__ + "img/back-gray.082ede15.png";